export default "__VITE_ASSET__A$LBeJ2k__"